@for (data of signatures; track data; let i = $index) {
  <div class="notes">
    <div class="notes-item">
      <strong>{{data?.name| uppercase}}</strong> <br>
      {{data?.description| uppercase}}
      @if ((data.firmantes && data.firmantes.length) || (data.fields && data.fields.length)) {
        <div class="notes-footer align-items-end mt-1">
          <p class="fields-title">Firmantes:</p>
          <ul class="fileds-list">
            @for (signer of (data.firmantes && data.firmantes.length ? data.firmantes : data.fields); track signer; let i = $index) {
              <li class="">
                {{signer.nombre || signer.name}}<br>
                @if (signer.email) {
                  <span>Email: {{signer.email}}</span>
                  }@if (signer.email) {
                  <br>
                  }
                  @if (signer.tipo) {
                    <span>Tipo: {{signer.tipo | titlecase}}</span>
                    }@if (signer.tipo) {
                    <br>
                    }
                    <i class="status-icon far ml-3 {{(signer.ready || signer.signStatus) ? 'fa-edit green' : 'fa-clock orange'}}" style="font-size: 1.9em; vertical-align: middle; margin-top: -20px;"></i>
                  </li>
                }
              </ul>
            </div>
          }
          @if (data.viewers && data.viewers.length) {
            <div class="notes-footer align-items-end mt-1">
              <p class="fields-title">Observadores:</p>
              <ul class="fileds-list">
                @for (viewer of data.viewers; track viewer; let i = $index) {
                  <li class="">
                    {{viewer.nombre || viewer.name}}<br>
                    @if (viewer.email) {
                      <span>Email: {{viewer.email}}</span>
                    }
                  </li>
                }
              </ul>
            </div>
          }
          @if (data.documentOriginalUrl) {
            <a class="dropdown-item icon-table" target="_blank" [href]="data.documentOriginalUrl">
              <i class="fas fa-download"></i>
              Descargar documento original
            </a>
          }
          @if (data.signedDocumentBase64) {
            <a class="dropdown-item icon-table" download="documento_firmado.pdf" [href]="'data:application/pdf;base64,' + data.signedDocumentBase64">
              <i class="fas fa-download"></i>
              Descargar documento firmado
            </a>
          }
          @if (data.signedDocumentUrl && !data.signedDocumentBase64) {
            <a class="dropdown-item icon-table" target="_blank" [href]="data.signedDocumentUrl ? data.signedDocumentUrl : data.document">
              <i class="fas fa-download"></i>
              Descargar documento firmado
            </a>
          }
          @if (canSendReminder(data)) {
            <button
              type="button"
              class="btn btn-sm btn-outline-primary mt-2 remind-btn"
              [disabled]="isReminding(data.signatureId)"
              (click)="sendReminder(data)">
              <i class="fas fa-bell mr-1"></i>
              @if (isReminding(data.signatureId)) {
                Enviando recordatorio...
              } @else {
                Enviar recordatorio a firmantes pendientes
              }
            </button>
          }
          <div class="notes-footer-right">
            <div class="notes-users">
              <ul class="list-unstyled users-list cursor-pointer m-0 d-flex ">
                <li class="avatar pull-up my-0 " triggers="click"  placement="left" [ngbTooltip]="data.name">
                  <app-avatar-photo [photoUrl]="undefined" [name]="data.createdBy" ></app-avatar-photo>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    }
